import Vue from 'vue'
import * as types from './mutation-types'
import * as R from 'ramda'

export default {
  [types.SET_USER_INFO] (state, { displayName, email, photoURL, uid, providerData, emailVerified, permissions }) {
    const setStateIfHasValue = (k, v) => R.when(v => v, v => Vue.set(state, k, v))(v)

    setStateIfHasValue('uid', uid)
    setStateIfHasValue('displayName', displayName)
    setStateIfHasValue('email', email)
    setStateIfHasValue('photoURL', photoURL)
    setStateIfHasValue('providerData', providerData)
    setStateIfHasValue('permissions', permissions)
    setStateIfHasValue('emailVerified', emailVerified)
  },
  [types.CLEAR_USER_INFO] (state) {
    state.uid = null
    state.displayName = ''
    state.email = ''
    state.photoURL = ''
    Vue.set(state, 'providerData', [])
    Vue.set(state, 'permissions', {})
  },
  [types.SET_SIGN_IN_STATUS] (state, status) {
    state.signInStatus = status
  },
  [types.SET_STORES] (state, stores) {
    Vue.set(state, 'stores', stores)
  }
}
